import { useState } from "react";
import "@/App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import TrustBar from "./components/TrustBar";
import Services from "./components/Services";
import RouteMap from "./components/RouteMap";
import ParallaxBanner from "./components/ParallaxBanner";
import HowItWorks from "./components/HowItWorks";
import Branches from "./components/Branches";
import BottomSection from "./components/BottomSection";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import QuoteDialog from "./components/QuoteDialog";
import { Toaster } from "./components/ui/sonner";

function App() {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const openQuote = () => setQuoteOpen(true);

  return (
    <div className="App" data-testid="app-root">
      <Header onQuoteClick={openQuote} />
      <main>
        <Hero onQuoteClick={openQuote} />
        <ParallaxBanner
          testId="parallax-banner-top"
          overline="Envíos NY → República Dominicana"
          title="El barco que lleva tus envíos a tu familia"
        />
        <TrustBar />
        <Services onQuoteClick={openQuote} />
        <RouteMap />
        <HowItWorks />
        <Branches />
        <BottomSection />
        <ParallaxBanner />
      </main>
      <Footer />
      <WhatsAppFloat />
      <QuoteDialog open={quoteOpen} onOpenChange={setQuoteOpen} />
      <Toaster />
    </div>
  );
}

export default App;
